import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import toast from "react-hot-toast";

const rawBaseQuery = fetchBaseQuery({
  baseUrl: process.env.REACT_APP_API_URL,
  prepareHeaders: (headers) => {
    const token = localStorage.getItem("token");
    if (token) headers.set("Authorization", `Bearer ${token}`);
    return headers;
  },
});

// wrapper with 401 handling

let isSessionExpired = false;

const baseQueryWithAuth: typeof rawBaseQuery = async (
  args,
  api,
  extraOptions
) => {
  const result = await rawBaseQuery(args, api, extraOptions);

  if (result.error && result.error.status === 401) {
    if (!isSessionExpired) {
      isSessionExpired = true; localStorage.removeItem("token");
      localStorage.setItem("isLogin", "false");
      api.dispatch({ type: "auth/logout" });

      toast.error("Session Expired", { duration: 1000 });

      setTimeout(() => {
        window.location.href = "/login";
        isSessionExpired = false
      }, 1000);
    }
  }

  return result;
};

export const baseApi = createApi({
  reducerPath: "baseApi",
  baseQuery: baseQueryWithAuth,
  tagTypes: ["Jobs", "Auth", "User", "Roles"],
  endpoints: () => ({}),
});
